import { getAreasOfNeed, populatePlaceholderText } from '@/api/presentlevels.js'

export function buildIODStatement({impactAreaStatements, subjectStatements, selectedDisability, selectedSubjects, selectedImpactAreas}) {
  let allStatementsForDisability = subjectStatements[selectedDisability]
  let statement = '';
  let isStatementEmptyPlaceholder = false;
  const hasSelectedImpactAreas = selectedImpactAreas.length > 0 && impactAreaStatements.length > 1
  const disabilityHasSingleImpactArea = impactAreaStatements.length <= 1
  const includeImpactAreaStatements = hasSelectedImpactAreas || disabilityHasSingleImpactArea
  const hasSelectedSubjects = selectedSubjects.length > 0
  if (includeImpactAreaStatements) {
    if (disabilityHasSingleImpactArea) {
      selectedImpactAreas = impactAreaStatements;
    }
    statement = compileImpactStatements(selectedImpactAreas, selectedSubjects, allStatementsForDisability)
    isStatementEmptyPlaceholder = false
  } else {
    if (hasSelectedSubjects) {
      statement = '[Select an impacted area to compose a statement.]'
      isStatementEmptyPlaceholder = true
    } else {
      statement = '[Select a subject and an impacted area to compose a statement.]'
      isStatementEmptyPlaceholder = true
    }
  }
  return [populatePlaceholderText(statement, {
    studentName: '(student)',
  }), isStatementEmptyPlaceholder];
}

function compileImpactStatements(selectedImpactAreas, selectedSubjects, allStatementsForDisability) {
  const hasSelectedSubjects = selectedSubjects.length > 0
  selectedImpactAreas.sort((a,b) => parseInt(a.area_order) - parseInt(b.area_order))
  let statement = ''
  selectedImpactAreas.forEach((ia) => {
    statement += ia.area_statement_text
    statement += ' '

    if (hasSelectedSubjects) {
      let statementsForSubject = allStatementsForDisability.filter(s => selectedSubjects.includes(s.subject) && s.area_uuid === ia.area_uuid)
      const subjectsInOrder = getAreasOfNeed({iodSubject: true}).map(s => s.label)
      statementsForSubject.sort((a,b) => {
        const aIndex = subjectsInOrder.indexOf(a.subject)
        const bIndex = subjectsInOrder.indexOf(b.subject)
        return aIndex - bIndex;
      })
      statementsForSubject.forEach((subject) => {
        statement += subject.statement_text
        statement += ' '
      })
    } else {
      statement += '\n\n[Select a subject to complete the statement.]'
    }

    statement += '\n\n'
  })
  return statement
}